
export default (width, height) => ({ minWidth: width, width: width, maxWidth: width, minHeight: height, height: height, maxHeight: height });